import { Container, Row, Col, Image } from 'react-bootstrap'
import FreeReportWYDModal from '../wyd/FreeReportWYDModal';
import { useState } from 'react'

function FreeReportWYD (props) {
    
    const [lgShow, setLgShow] = useState(false);
    
    return (
        <>
            <div className="section-free-report">
                <Container>
                    <Row>
                        <Col md={4}>
                            <Image src="../images/wyd/img-ebook-doctor09.png" alt="What your Doctor" className="img-fluid d-block w-auto mx-auto"/>
                            <br/><br/>
                        </Col>
                        <Col md={8}>
                            <h2><span className="text-free-report">FREE REPORT!</span>
                            What your Doctor wasn't taught in med school<br/>
                            <span className="text-about-nutrition">about nutrition that you need to know</span></h2>
                            <p className="text-click-button">CLICK THE BUTTON BELOW TO GET THIS <strong>FREE REPORT</strong></p>
                            <p><a className="btn btn-download" onClick={() => setLgShow(true)}>DOWNLOAD NOW</a></p>
                        </Col>
                    </Row>
                </Container>
            </div>
            <FreeReportWYDModal show={lgShow} onHide={() => setLgShow(false)} global={props.global}/>
            <style jsx global>{`

                .section-free-report {
                    background: #00aec7;
                    font-size: 16px;
                }

                .section-free-report .container {
                    padding-top: 50px;
                }

                .section-free-report h2 {
                    font-family: 'Bebas Neue', Helvetica, Arial, sans-serif;
                    font-size: 46px;
                    margin-top: 40px;
                    margin-bottom: 25px;
                }

                .section-free-report h2 .text-free-report {
                    color: #fff;
                    display: block;
                    margin-bottom: 15px;
                }

                .section-free-report h2 .text-about-nutrition {
                    font-family: 'Poppins', Helvetica, Arial, sans-serif;
                    font-size: 30px;
                    line-height: 25px;
                    display: block;
                    letter-spacing: 2px;
                }

                .section-free-report img {
                    border: 9px solid #00aec7;
                }

                .section-free-report p {
                    margin-bottom: 40px;
                    line-height: 36px;
                }

                .section-free-report strong {
                    color: #fff;
                }

                .section-free-report .text-click-button {
                    margin-bottom: 5px;
                }

                .section-free-report .btn-download {
                    font-family: 'Bebas Neue', Helvetica, Arial, sans-serif;
                    font-size: 44px;
                    background: #94b92c;
                    padding: 7px 45px 2px;
                    border-radius: 0px;
                    color: #fff;
                }

                .section-free-report .btn-download:hover {
                    background: #86a62e;
                }

                @media (max-width: 767.98px) {	

                    .section-free-report .container {
                        padding-top: 20px;
                    }

                    .section-free-report h2 {
                        font-size: 37px;
                        margin-top: -40px;
                        margin-bottom: 25px;
                    }

                    .section-free-report h2 .text-free-report {
                        margin-bottom: 0px;
                    }

                    .section-free-report img {
                        margin: 0px auto;
                    }

                    .section-free-report .btn-download {
                        font-size: 34px;
                        padding: 7px 35px 2px;
                    }

                }

            `}</style>
        </>
    );
}

export default FreeReportWYD;